// extracted by mini-css-extract-plugin
export default {"configuration":"style_configuration__qoxbq","checkboxConfig":"style_checkboxConfig__NhR2F","addDate":"style_addDate__D22Qz","simulationDate":"style_simulationDate__19ATs"};